<template>
  <div id="app" :class="{ 'p-top-0': !$store.state.logged }">
    <notifications />

    <div :class="{ 'mb-0': $store.state.logged && showMenu, 'h-100': true }">
      <router-view />
    </div>
    <Footer v-if="$store.state.logged && showMenu" class="fadeIn" />
    <div v-show="showBackground" id="bg-image"></div>
  </div>
</template>

<script type="text/javascript">
import { Loader } from "google-maps";
import Footer from "@/components/footer/Footer.vue";
import CommonComponent from "@/components/utils/CommonComponent.vue";
import { mapActions } from 'vuex';

const MapLoader = new Loader(process.env.VUE_APP_KEY_GOOGLE_MAP, {});

export default {
  name: "App",
  extends: CommonComponent,
  components: {
    Footer,
  },
  data() {
    return {};
  },

  methods: {
    ...mapActions(["changeBackground"]),
  },

  beforeMount() {
    this.consts.Google.MAP_LOADER = MapLoader;
    setInterval(() => {
      this.changeBackground();
    }, process.env.VUE_APP_REFRESH_BG_MS);
  },
  mounted() {
    this.changeBackground();
  },

  beforeUpdate() {},

  computed: {},
};
</script>

<style lang="scss">
@import "@/assets/styles/app.scss";
@import "@/assets/styles/buttons.scss";

#bg-image {
  top: 0;
  z-index: -1;
  position: absolute;
  height: 100vh;
  width: 100vw;
  background-size: cover;
  background-repeat: no-repeat;
}

@keyframes bg-fadeOut {
  0% {
    opacity: 1;
  }
   100% {
    opacity: 0;
  }
}

.bg-fadeOut {
  animation-name: bg-fadeOut;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
  animation-duration: 2s;
  animation-direction: alternate;
}

@keyframes bg-fadeIn {
  0% {
    opacity: 0;
  }
   100% {
    opacity: 1;
  }
}
.bg-fadeIn {
  animation-name: bg-fadeIn;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
  animation-duration: 2s;
  animation-direction: alternate;
}
</style>
